// Path-based gate for the character-builder route.
//
// The app has no react-router; routing happens via inspection in src/index.js
// `Root`. This mirrors the pattern used by `shouldForceLocalMode()` (which
// reads `?local=1`) but with a pathname check instead of a query param.
//
// The character-builder route is intentionally auth-bypassed for Phase 1 —
// it's a standalone scaffold. When the builder needs Convex (Phase 7),
// the consuming component can mount its own provider.

export const CHARACTER_BUILDER_PATH = '/character-builder';

export const isCharacterBuilderRoute = () => {
  if (typeof window === 'undefined') return false;
  if (!window.location) return false;
  return window.location.pathname === CHARACTER_BUILDER_PATH;
};
